/** 目標/計畫/每期保費暨配置比例/繳別變更 */
import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A9';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 取得條款說明 */
export function getAgreeTermsA9() {
    return get(`${url}/getAgreeTerms`);
};

/** 條款同意 */
export function postAgreeA9() {
    return post(`${url}/agree`);
};

/** 保戶進入新台幣貨幣帳戶定期定額投資金額轉換前，取得先前定期定額投資金額記錄 */
export function getInfoA9() {
    return get(`${url}/info`);
};

/** 取得投資標的公司及投資標的名稱下拉式選單 */
export function getFundBankInfoA9() {
    return get(`${url}/fundBankInfo`);
}

/** A9 變更送出 */
export function submitA9(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};
